import type { CSSProperties, ReactNode } from 'react';

import { cx } from './classNames';
import { resolveIconClass } from './icons';
import { Spinner } from './Spinner';

/** Pendant zu `SfProgressButton`; `progress` entspricht `EnableProgress`. */
export interface ProgressButtonProps {
  children?: ReactNode;
  content?: string;
  iconClass?: string;
  progress?: boolean;
  primary?: boolean;
  flat?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit';
  title?: string;
  id?: string;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void | Promise<void>;
}

export function ProgressButton(props: ProgressButtonProps) {
  const label = props.content ?? props.children;
  const iconOnly = label === undefined || label === null || label === '';
  const icon = resolveIconClass(props.iconClass);
  const running = props.progress === true;

  return (
    <button
      id={props.id}
      type={props.type ?? 'button'}
      title={props.title}
      style={props.style}
      disabled={props.disabled === true || running}
      aria-busy={running}
      aria-label={iconOnly ? props.title : undefined}
      className={cx(
        'e-btn',
        'e-progress-btn',
        props.primary === true && 'e-primary',
        props.flat === true && 'e-flat',
        iconOnly && icon !== undefined && 'e-icon-btn',
        running && 'e-progress-active',
        props.className,
      )}
      onClick={() => {
        void props.onClick?.();
      }}
    >
      <span className="e-progress" />
      <span className="e-btn-content">
        {icon === undefined ? null : (
          <span className={cx('e-btn-icon', 'e-icons', iconOnly && 'e-icon-only', icon)} />
        )}
        {label}
      </span>
      {running ? <Spinner size={16} className="e-spin-left e-spinner" /> : null}
    </button>
  );
}

export default ProgressButton;
